import isEmpty from "lodash/isEmpty";

import { TextTestID, WeightTrackingTestID } from "@/constants/TestID";
import BoldWeightText from "@/ui/components/vitals/BoldWeightText";
import { Text } from "@/ui/core";
import { Box, FlatList, HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";
import { getObservedAt, getRoundedValue } from "@/utils/vitals/weight.util";

interface BriefWeightEntriesProps {
  data: PatientObservationData[];
}

const BriefWeightEntries = ({ data }: BriefWeightEntriesProps) => {
  if (isEmpty(data)) {
    return null;
  }
  const baseTestID = WeightTrackingTestID.BriefWeightEntries;
  return (
    <FlatList
      data={data}
      isScrollEnabled={false}
      keyExtractor={(item) => item.observation.externalId}
      renderItem={({ item }) => {
        return (
          <HStack gap={12} justifyContent="flex-start">
            <Box width={90}>
              <BoldWeightText
                testID={baseTestID}
                text={item.observation.unit}
                weight={getRoundedValue(item.observation.value).toString()}
              />
            </Box>
            <Text
              color={ColorToken.NeutralSecondary}
              testID={joinTestIDs(baseTestID, TextTestID.Date)}
              variant="caption"
            >
              {getObservedAt(item)}
            </Text>
          </HStack>
        );
      }}
      shouldRemoveContentVerticalPadding
      shouldRemoveStyleHorizontalPadding
      testID={baseTestID}
    />
  );
};

export default BriefWeightEntries;
